import React from "react";
import PrizesCard from "./prizesCard";
import { useSubscriptionCompetitionsPrizesPageContext } from "../context";

const PrizesGrid = () => {
  const { competitionDetails } = useSubscriptionCompetitionsPrizesPageContext();
  if (competitionDetails.prizes.length === 0) {
    return null;
  }
  return (
    <div className={"w-full flex flex-col gap-4 lg:gap-5 items-start"}>
      <div className={"text-[#28282B] font-jost text-base font-semibold lg:font-medium leading-[22px]"}>
        Prizes for this competition
      </div>
      <div className={"grid grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-3"}>
        {competitionDetails.prizes.map((prize, index) =>
          Array(prize.quantity)
            .fill({})
            .map((_, idx) => <PrizesCard key={`${prize.title}-${idx}`} prize={prize} />)
        )}
      </div>
    </div>
  );
};

export default PrizesGrid;
